import gql from "graphql-tag";
import { ReleaseFrequency, UpdateStrategy } from "../../graphql";

/**
 * graphql query to get all information for the version management form
 */
export const VERSION_MANAGEMENT_GET_FORM_DATA = gql`
    query versionManagementGetFormData {
        company {
            name
            userGroups {
                id
                name
                softwareVersion {
                    updateStrategy
                    tag {
                        id
                        name
                        releaseFrequency
                    }
                    selectedVersion {
                        productVersion
                    }
                }
            }
        }
        getSoftwareTags {
            id
            name
            releaseFrequency
            isDefaultForReleaseFrequency
        }
        getCompanySoftwareVersion {
            updateStrategy
            bundle {
                id
                bundleVersion
            }
            tag {
                id
                name
                internal
                releaseFrequency
                isDefaultForReleaseFrequency
            }
        }
        getSelectedPrintVersion {
            productVersion
        }
    }
`;

/**
 * Represents a software bundle (having an id and a version)
 * there is more data available, but we only need the id and the bundleVersion
 */
export interface SoftwareBundle {
    id: number;
    bundleVersion: string;
}
/**
 * Represents a software tag (having an id and a name)
 */
export interface SoftwareTag {
    id: number;
    name: string;
    internal?: boolean;
    isDefaultForReleaseFrequency?: boolean;
    releaseFrequency?: ReleaseFrequency;
}
/**
 * Represents a software bundle version (having an id, a bundleVersion and an optional array of tags)
 */
export interface SoftwareBundleVersion {
    id: number;
    bundleVersion: string;
    tags?: SoftwareTag[];
}
/**
 * Represents a print version (having a productVersion)
 */
export interface PrintVersion {
    productVersion: string;
}

/**
 * Represents the result of the version management query
 */
export interface VersionManagementGetFormDataResult {
    company: {
        name: string;
        userGroups: {
            id: number;
            name: string;
            softwareVersion?: {
                updateStrategy: UpdateStrategy;
                tag: {
                    id: number;
                    name: string;
                    releaseFrequency: ReleaseFrequency;
                };
                selectedVersion: {
                    productVersion: string;
                };
            };
        }[];
    };
    getCompanySoftwareVersion: {
        updateStrategy?: UpdateStrategy;
        bundle?: SoftwareBundle;
        tag?: SoftwareTag;
    };
    getSoftwareTags: SoftwareTag[];
    getSelectedPrintVersion?: PrintVersion;
}

/**
 * graphql mutation to update the company and groups software version data
 */
export const UPDATE_SOFTWARE_VERSIONS = gql`
    mutation updateSoftwareVersions(
        $company: UpdateCompanySoftwareVersionInput
        $groups: [UpdateGroupSoftwareVersionInput]
    ) {
        updateSoftwareVersion(data: { company: $company, groups: $groups })
    }
`;

export const GET_PREVIEW_PRINT_VERSION = gql`
    query getPreviewPrintVersion($updateStrategy: String!, $tag: Int) {
        getPreviewPrintVersion(data: { updateStrategy: $updateStrategy, tag: $tag }) {
            productVersion
        }
    }
`;
